document.addEventListener("DOMContentLoaded", function () {
    const STORAGE_KEY = "umerzaman152_inventory_cycle";
    const inventoryEl = document.querySelector(".minventory-box[data-inventory-seconds]");

    const STEP_TIME = inventoryEl
        ? (parseInt(inventoryEl.dataset.inventorySeconds, 10) || 300) * 1000
        : 300 * 1000;

    function getNextValue(current) {
        switch (current) {
            case 7:
                return 5;
            case 5:
                return 4;
            case 4:
                return 3;
            case 3:
            default:
                return 3; // Stay at 3 forever
        }
    }

    let data = JSON.parse(localStorage.getItem(STORAGE_KEY));
    const now = Date.now();

    // First visit
    if (!data) {
        data = {
            number: 7,
            nextUpdate: now + STEP_TIME
        };
    }

    // Handle missed intervals (but stop once it reaches 3)
    while (now >= data.nextUpdate && data.number !== 3) {
        data.number = getNextValue(data.number);

        if (data.number !== 3) {
            data.nextUpdate += STEP_TIME;
        }
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

    function render() {
        document.querySelectorAll(".randomnumber-by-umerzaman152").forEach(function (el) {
            el.textContent = data.number;
        });
    }

    render();

    // Check every 10 seconds
    setInterval(function () {
        const currentTime = Date.now();
        let changed = false;

        while (currentTime >= data.nextUpdate && data.number !== 3) {
            data.number = getNextValue(data.number);

            if (data.number !== 3) {
                data.nextUpdate += STEP_TIME;
            }

            changed = true;
        }

        if (changed) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            render();
        }
    }, 10000);
});